import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-inprogress-appointment',
  templateUrl: './inprogress-appointment.component.html',
  styleUrls: ['./inprogress-appointment.component.scss']
})
export class InprogressAppointmentComponent implements OnInit {
  apptId: any;
  appointmentStatus: any;
  isApptCompleted: boolean=false;

  constructor(private formBuilder: FormBuilder ,private spinner: NgxSpinnerService, private http: HttpClient, private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService, private authService: AuthenticationService, private router: Router) { }

  value: String = "Upcoming";
  appointments: any = []
  userRole: any
  status!: string
  filterForm!: FormGroup;
  tests: any
  surveys: any
  selectedTests: any
  selectedSurveys: any
  disabledButton: boolean = false
  show: boolean = false
  schedules:any
  page=4



  ngOnInit(): void {
    let location = null;
    let diagId = null;
    this.status = "ASSESMENT"
    this.show = false;
    jQuery('.modal-backdrop.fade.show').remove();
    this.spinner.show()

    this.userRole = this.authService.getUserType()
    if (this.userRole != 'ADMIN' && this.userRole!='DIRECTOR') {
      diagId = this.authenticationService.getUserId();
    }
    this.appointmentService.getAppointments(location, diagId, this.status, null, null, null).subscribe((res: any) => {
      this.appointments = res.data;

      this.show = true;

      this.spinner.hide()

    })

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
    });
  }


  submitFilterForm() {
    this.spinner.show()
    this.appointmentService.getAppointments(null,null,this.status,null, this.filterForm.controls['fromDate'].value, this.filterForm.controls['toDate'].value).subscribe((res: any)=>{
      this.appointments=res.data;
      this.show=true
      this.spinner.hide()
    })
  }

  getAppointments() {

  }
  selectValue(value: string) {
    this.value = value;


  }
  setApptId(apptId: any,apptStatus:any) {
    this.isApptCompleted=false

    if(apptStatus=="COMPLETE" || apptStatus=="CANCEL"){
      this.isApptCompleted=true
    }
    
    this.apptId = apptId
    
  }
  getTestTypes() {

  }
  addSurveys() {
    var surveys = this.surveys.surveysList
      .filter((opt: { checked: any; }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedSurveys = surveys;


    var tests = this.surveys.testsList
      .filter((opt: { checked: any; }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedTests = tests;

    let selectedDetails = {
      tests: this.selectedTests,
      surveys: this.selectedSurveys,
      appointmentId: this.apptId
    }
    this.appointmentService.saveSurveyDetails(selectedDetails).subscribe(res => {
      location.reload();
    })


  }
  disableButton() {
  }

 

}
